import React from 'react';

import classNames from 'classnames';

import CheckIcon from 'Assets/icons/check.svg';

const UploadProgressCircle = ({ progress = 0, size = 48, strokeWidth = 4 }) => {
    const radius = (size - strokeWidth) / 2;
    const circumference = radius * 2 * Math.PI;
    const strokeDashoffset = circumference - (progress / 100) * circumference;

    return (
        <div className="tw-relative tw-inline-flex tw-items-center tw-justify-center">
            <svg width={size} height={size} className="tw-transform -tw-rotate-90">
                {/* Background circle */}
                <circle cx={size / 2} cy={size / 2} r={radius} fill="none" stroke="currentColor" strokeWidth={strokeWidth} className="tw-text-gray-200" />
                {/* Progress circle */}
                <circle
                    cx={size / 2}
                    cy={size / 2}
                    r={radius}
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={strokeWidth}
                    strokeDasharray={circumference}
                    strokeDashoffset={strokeDashoffset}
                    strokeLinecap="round"
                    className={classNames('tw-transition-all tw-duration-300 tw-ease-out', progress === 100 ? 'tw-text-green-500' : 'tw-text-blue-500')}
                />
            </svg>
            {/* Percentage text */}
            <span className="tw-absolute tw-text-xs tw-font-medium tw-text-gray-700">
                {progress < 100 ? <span>{Math.round(progress)}%</span> : <CheckIcon className="tw-w-4 tw-h-4 tw-text-green-500" />}
            </span>
        </div>
    );
};

export default UploadProgressCircle;
